module.exports = __webpack_public_path__ + "img/santagoose.49d8349b.png";